import DateFnsUtils from "@date-io/date-fns";
import { Card, FormControl, FormGroup, Grid, Icon } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { saveAs } from "file-saver";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { getData } from "../../api/apiCaller";
import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { mapActionsToProps as agentAction } from "./../../redux/agent";
import { mapActionsToProps as phoneNumberAction } from "./../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps } from "./../../redux/dashboard";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
});

class ReportSynthesisDaily extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        from: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
        to: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
      },
      loading: false,
    };
  }

  async componentDidMount() {}

  async callApiGetCities(name = null, limit) {
    const where = {
      ...(name && { name: { like: name, options: "i" } }),
    };
    const { data } = await getData("/vnpost/city-post-office", {
      filter: { where, limit },
    });
    this.setState({ listCities: data });
  }

  async callApiGetCTCenter(name = null, limit) {
    const where = {
      ...(name && { name: { like: name, options: "i" } }),
    };
    const { data } = await getData("/vnpost/contact-center", {
      filter: { where, limit },
    });
    this.setState({ contactCenters: data });
  }

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  exportFile = async () => {
    const { filters } = this.state;
    const { from, to } = filters;
    this.setState({ loading: true });
    const { data } = await getData("/cloud-pbx/report-synthesis-daily", {
      from,
      to,
    });
    this.setState({ loading: false });
    const fileName = data.fileUrl.split("/").pop();
    saveAs(data.fileUrl, fileName);
  };

  render() {
    const { classes, contacts } = this.props;
    const { filters, loading } = this.state;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Từ ngày"
                          variant="outlined"
                          className={classes.input}
                          value={filters.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Đến ngày"
                          variant="outlined"
                          className={classes.input}
                          value={filters.to}
                          maxDate={new Date()}
                          minDate={filters.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            style={{ marginLeft: "15px", marginTop: "15px" }}
                            className={classes.fab}
                            onClick={this.exportFile}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>

        <Dialog open={loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

ReportSynthesisDaily.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  inboundHours: state.dashboard.inbound,
  contacts: state.dashboard.contact,
  loading: state.dashboard.loading,
});
const NumberConnect = connect(null, phoneNumberAction)(ReportSynthesisDaily);
const Group = connect(null, agentAction)(NumberConnect);
ReportSynthesisDaily = connect(mapStateToProps, mapActionsToProps)(Group);
export default withStyles(styles)(ReportSynthesisDaily);
